<template>
  <component :is="dashboard()" />
</template>

<script>
import AdminDashboard from '@/components/AdminDashboard.vue'
import BorrowerDashboard from '@/components/BorrowerDashboard.vue'
import InvestorDashboard from '@/components/InvestorDashboard.vue'

export default {
  components: {
    AdminDashboard,
    BorrowerDashboard,
    InvestorDashboard
  },

  metaInfo: {
    title: 'Dashboard'
  },

  methods: {
    dashboard () {
      const role = this.$_.upperFirst(this.$auth.user.role.alias)

      return `${role}Dashboard`
    }
  }
}
</script>
